import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const blogSlice = createApi({
    reducerPath: "blogSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: commonBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getBlogs: builder.query({
            query: ({ page = 1, limit = 10, search = "", type = "blog" }) => ({
                url: `/blog?page=${page}&limit=${limit}&search=${search}&type=${type}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addBlog: builder.mutation({
            query: (body) => ({
                url: "/blog",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateBlog: builder.mutation({
            query: ({ id, body }) => ({
                url: `/blog/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteBlog: builder.mutation({
            query: (id) => ({
                url: `/blog/${id}`,
                method: "DELETE",
            }),
        }),

        getSingleBlog: builder.query({
            query: (id) => ({
                url: `/blog/${id}`,
                method: "GET",

            }),
        }),
    }),
});

export const {
    useGetBlogsQuery,
    useAddBlogMutation,
    useUpdateBlogMutation,
    useDeleteBlogMutation,
    useGetSingleBlogQuery
} = blogSlice;
